import CriptoJS from "crypto-js";
import { env } from "../../config";

// criptografa a rota antes de armazenar na sessionStorage criptoJs
export const encryptRoute = (route: string): string => {
	const encryptedRoute = CriptoJS.AES.encrypt(route, env.cryptoKey).toString();

	return encryptedRoute;
};

// decodifica a rota antes de retornar
export const decryptRoute = (encryptedRoute: string): string => {
	const decryptedRoute = CriptoJS.AES.decrypt(encryptedRoute, env.cryptoKey).toString(CriptoJS.enc.Utf8);

	return decryptedRoute;
};
